import React from 'react';
import { Route } from 'react-router-dom';
import VendasOnlineParceiroPayment from './index';

export default (
  <Route
    path="/homepage/pagamento/:id"
    component={VendasOnlineParceiroPayment}
  />
);
